import ReactGA from "react-ga4";

// lib/gtag.js
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID; // Replace with your actual ID

export const initGA = () => {
    ReactGA.initialize(GA_MEASUREMENT_ID); // Replace with your GA4 Measurement ID
};

export const trackPageview = (url) => {
    ReactGA.send({ hitType: "pageview", page: url });
};
